import React from 'react'
import MaskedInput from 'react-text-mask'
import createNumberMask from 'text-mask-addons/dist/createNumberMask'

const defaultMaskOptions = {
  prefix: '$',
  suffix: '',
  includeThousandsSeparator: true,
  thousandsSeparatorSymbol: ',',
  allowDecimal: true,
  decimalSymbol: '.',
  decimalLimit: 2,
  integerLimit: 10,
  allowNegative: false,
  allowLeadingZeroes: false,
}

const CurrencyInput = ({ ...inputProps }) => {
  const prefix = inputProps.prefix ?? defaultMaskOptions.prefix
  const suffix = inputProps.suffix ?? defaultMaskOptions.suffix
  const allowNegative =
    inputProps.allowNegative ?? defaultMaskOptions.allowNegative

  const currencyMask = createNumberMask({
    ...defaultMaskOptions,
    prefix,
    suffix,
    allowNegative,
  })

  return <MaskedInput mask={currencyMask} {...inputProps} />
}

export default CurrencyInput
